import React, { useEffect, useState } from "react";
import api from "../../utils/axiosInstance";
import AdminSideMenu from '../../components/AdminSideMenu';

const DriverAssignMonitor = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [triggering, setTriggering] = useState(false);
    const [selectedCarrier, setSelectedCarrier] = useState(null);
    const [carrierDetails, setCarrierDetails] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchDashboard();
    }, []);

    const fetchDashboard = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get('/driver-assignments/dashboard');
            setDashboardData(response.data);
        } catch (error) {
            console.error('Error fetching dashboard:', error);
            setError('Failed to load dashboard data. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const triggerAssignment = async () => {
        if (!window.confirm('Auto-assign Drivers now? This will assign drivers to all carriers with active subscriptions.')) {
            return;
        }

        try {
            setTriggering(true);
            await api.post('/driver-assignments/auto-assign-trigger');
            alert('Auto-assignment successfull!');
            fetchDashboard();
        } catch (error) {
            console.error('Error triggering assignment:', error);
            alert('Failed to assign Drivers');
        } finally {
            setTriggering(false);
        }
    };



    if (loading) {
        return (
            <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
                <AdminSideMenu />
                <div className="flex items-center justify-center w-full md:ml-64 min-h-screen">
                    <div className="text-center">
                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                        <p className="text-xl text-gray-600">Loading dashboard...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
                <AdminSideMenu />
                <div className="flex items-center justify-center w-full md:ml-64 min-h-screen">
                    <div className="text-center">
                        <div className="text-red-600 text-xl mb-4">⚠️ {error}</div>
                        <button
                            onClick={fetchDashboard}
                            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                        >
                            Retry
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (!dashboardData) {
        return (
            <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
                <AdminSideMenu />
                <div className="flex items-center justify-center w-full md:ml-64 min-h-screen">
                    <div className="text-center text-gray-600">No data available</div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
            <AdminSideMenu />

            <div className="w-full md:ml-64 p-4 sm:p-6 lg:p-8">
                {/* Header */}
                <header className="mb-8">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                Driver Assignment Dashboard
                            </h1>
                            <p className="text-gray-600">
                                Auto-assignment status for {new Date(dashboardData.date).toLocaleDateString('en-US')}
                            </p>
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={triggerAssignment}
                                disabled={triggering}
                                className="px-6 py-3 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {triggering ? 'Assigning...' : 'Auto Assign Drivers'}
                            </button>
                        </div>
                    </div>
                </header>

                {/* Summary Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="bg-white p-6 rounded-lg shadow">
                        <div className="text-sm text-gray-600 mb-2">Total Carriers with Package</div>
                        <div className="text-3xl font-bold text-gray-900">
                            {dashboardData.summary.carriersWithSubscription}
                        </div>
                    </div>

                    {/* <div className="bg-white p-6 rounded-lg shadow">
                        <div className="text-sm text-gray-600 mb-2">Drivers Assigned Today</div>
                        <div className="text-3xl font-bold text-green-600">
                            {dashboardData.summary.totalDriversAssignedToday}
                        </div>
                    </div> */}
                </div>

                {/* Carrier Cards */}
                {dashboardData.carriers && dashboardData.carriers.filter(c => c.hasSubscription).length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {dashboardData.carriers
                            .filter(c => c.hasSubscription)
                            .map((carrier) => (

                                <div
                                    key={carrier.carrierId}
                                    className={`bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition ${!carrier.hasSubscription ? 'opacity-60' : ''
                                        }`}
                                >
                                    {/* Carrier Header */}
                                    <div className="flex justify-between items-start mb-4">
                                        <div>
                                            <h3 className="text-lg font-bold text-gray-900">
                                                {carrier.carrierName}
                                            </h3>
                                            {carrier.hasSubscription ? (
                                                <span className="inline-block px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 mt-1">
                                                    Subscribed
                                                </span>
                                            ) : (
                                                <span className="inline-block px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800 mt-1">
                                                    No Subscription
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* Stats */}
                                    <div className="space-y-3 mb-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Total Drivers:</span>
                                            <span className="font-semibold text-gray-900">
                                                {carrier.totalDrivers}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Assigned Today:</span>
                                            <span className="font-semibold text-green-600">
                                                {carrier.assignedToday}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600">Favorite Drivers:</span>
                                            <span className="font-semibold text-green-600">
                                                {carrier.interestedCount}
                                            </span>
                                        </div>
                                        {carrier.autoAssignmentEnabled && (
                                            <div className="flex justify-between items-center">
                                                <span className="text-sm text-gray-600">Per Day:</span>
                                                <span className="font-semibold text-purple-600">
                                                    {carrier.driversPerDay}
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    {/* Progress Bar */}
                                    {carrier.hasSubscription && (
                                        <div className="mb-4">
                                            <div className="w-full bg-gray-200 rounded-full h-2">
                                                <div
                                                    className="bg-blue-600 h-2 rounded-full transition-all"
                                                    style={{
                                                        width: `${Math.min(
                                                            (carrier.assignedToday / carrier.expectedToday) * 100,
                                                            100
                                                        )}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                    </div>
                ) : (
                    <div className="text-center text-gray-600 py-12">
                        <p className="text-xl">No carriers found</p>
                    </div>
                )}

                {/* Carrier Details Modal */}
                {selectedCarrier && carrierDetails && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="p-6 border-b sticky top-0 bg-white z-10">
                                <div className="flex justify-between items-center">
                                    <h2 className="text-2xl font-bold">
                                        {carrierDetails.carrier.name}
                                    </h2>
                                    <button
                                        onClick={() => {
                                            setSelectedCarrier(null);
                                            setCarrierDetails(null);
                                        }}
                                        className="text-gray-500 hover:text-gray-700 text-3xl leading-none"
                                    >
                                        ×
                                    </button>
                                </div>
                            </div>

                            <div className="p-6">
                                {/* Carrier Info */}
                                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                    <h3 className="font-semibold mb-2">Carrier Information</h3>
                                    <div className="grid grid-cols-2 gap-4 text-sm">
                                        <div>
                                            <span className="text-gray-600">Total Drivers:</span>
                                            <span className="ml-2 font-semibold">
                                                {carrierDetails.carrier.totalDrivers}
                                            </span>
                                        </div>
                                        {carrierDetails.carrier.subscription && (
                                            <>
                                                <div>
                                                    <span className="text-gray-600">Auto-Assignment:</span>
                                                    <span className="ml-2 font-semibold">
                                                        {carrierDetails.carrier.subscription.autoAssignment ? 'Enabled' : 'Disabled'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span className="text-gray-600">Drivers Per Day:</span>
                                                    <span className="ml-2 font-semibold">
                                                        {carrierDetails.carrier.subscription.driversPerDay}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Assignments by Date */}
                                <h3 className="font-semibold mb-4">Assignments (Last 30 Days)</h3>
                                {Object.keys(carrierDetails.assignmentsByDate).length > 0 ? (
                                    <div className="space-y-4">
                                        {Object.entries(carrierDetails.assignmentsByDate)
                                            .sort(([dateA], [dateB]) => dateB.localeCompare(dateA))
                                            .map(([date, drivers]) => (
                                                <div key={date} className="border rounded-lg p-4">
                                                    <div className="flex justify-between items-center mb-3">
                                                        <h4 className="font-semibold text-gray-900">
                                                            {new Date(date).toLocaleDateString('en-US', {
                                                                weekday: 'short',
                                                                year: 'numeric',
                                                                month: 'short',
                                                                day: 'numeric'
                                                            })}
                                                        </h4>
                                                        <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold">
                                                            {drivers.length} drivers
                                                        </span>
                                                    </div>
                                                    <div className="space-y-2">
                                                        {drivers.map((driver, idx) => (
                                                            <div
                                                                key={idx}
                                                                className="flex justify-between items-center text-sm p-2 bg-gray-50 rounded"
                                                            >
                                                                <span className="font-medium">
                                                                    {driver.driverName || 'N/A'}
                                                                </span>
                                                                <span className="text-gray-600">
                                                                    {driver.driverEmail || 'N/A'}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                ) : (
                                    <div className="text-center text-gray-500 py-8">
                                        No assignments in the last 30 days
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DriverAssignMonitor;